export default "__VITE_ASSET__CC_72wua__"